import { Component, Input, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { BasicTextInputComponent } from '../../form/base-components/base-text-input/basic-text-input.component';
import { AmorphicService } from '../../../services/amorphic/amorphic.service';
import { BaseLoginService } from '../../../services/login/base-login.service';
import { FormService } from '../../../services/form/form.service';
import { ValidationService } from '../../../services/validation/validation.service';

@Component({
  moduleId: module.id,
  selector: 'base-register',
  templateUrl: './base-register.component.html',
})
export class BaseRegisterComponent {
  @Input() continueRegister: boolean;
  @ViewChild('registerEmail') registerEmailInput: BasicTextInputComponent;
  @ViewChild('registerPassword') registerPasswordInput: BasicTextInputComponent;
  @ViewChild('registerFirstName') registerFirstNameInput: BasicTextInputComponent;
  @ViewChild('registerLastName') registerLastNameInput: BasicTextInputComponent;
  controller;
  isVerified: boolean = false;
  isLoading: boolean;
  errorMessage: string;
  buttonDisabled: boolean;

  constructor(
    private amorphicService: AmorphicService,
    private validationService: ValidationService,
    private loginService: BaseLoginService,
    private router: Router,
    private formService: FormService
  ) {
    this.controller = amorphicService.controller;
  }

  ngOnChanges(): void {
    if (this.continueRegister) {
      this.isVerified = true;
      this.register(true);
    }
  }

  async register(noValidate?: boolean): Promise<void> {
    if (!noValidate && !this.validate()) {
      return;
    }

    this.isLoading = true;

    try {
      await this.loginService.accountExists();
      const success = await this.loginService.register();

      this.controller.finalizeRegistration();
      this.router.navigate(['application-form']);
    } catch (error) {
      this.isLoading = false;
      if (error.code === 'account_exists') {
        this.errorMessage = 'Account already exists with this email.';
        return;
      } else if (error.code === 'create_customer_failed') {
        this.errorMessage = 'Failed to create customer.';
        return;
      }
    }
  }

  validate(): boolean {
    const emailToLower = this.registerEmailInput.val.toLowerCase();
    this.errorMessage = '';
    this.controller.email = emailToLower;
    this.registerEmailInput.val = emailToLower;

    if (
      this.registerEmailInput.val &&
      !this.registerEmailInput.isError &&
      this.registerPasswordInput.val &&
      !this.registerPasswordInput.isError &&
      this.registerFirstNameInput.val &&
      !this.registerFirstNameInput.isError &&
      this.registerLastNameInput.val &&
      !this.registerLastNameInput.isError &&
      this.isVerified
    ) {
      this.controller.confirmPassword = this.registerPasswordInput.val;

      this.buttonDisabled = false;
      return true;
    } else {
      this.buttonDisabled = true;
      return false;
    }
  }

  goToLogin(): void {
    this.loginService.goToLogin();
  }
}
